export const restaurantOrdersNl = {
  title: {
    deliveryTakeaway: 'Delivery & afhalen',
    deliveryTakeawayConfiguration: 'Configuratie Delivery & afhalen',
    orderHistoryDocument: 'Bestelgeschiedenis · Delivery & afhalen',
    orderHubEyebrow: 'Bestelcentrum',
    operationalManagement: 'Operationeel beheer',
  },
  workspace: {
    selectBranchToManage: 'Selecteer een vestiging om {{title}} te beheren.',
    newOrder: 'Nieuwe bestelling',
    searchOrderPlaceholder: 'Bestelling zoeken…',
    orderTypeAriaLabel: 'Type bestelling',
    channelDelivery: 'DELIVERY',
    channelTakeaway: 'AFHALEN',
    processedAriaLabel: 'Verwerkt',
    processedTitle: 'Verwerkte bestellingen',
    processed: 'Verwerkt',
    refreshOrdersLabel: 'Bestellingen vernieuwen',
    refreshOrdersTitle: 'Bestellingen vernieuwen',
    attentionLabel: 'Te beheren',
    unsupportedStatesAlert:
      '{{count}} bestellingen hebben API-statussen die niet compatibel zijn met de nieuwe workflow.',
    unsupportedStatesHint:
      'Ze verschijnen in de kalender, maar kunnen niet automatisch aan bordkolommen worden toegewezen. Controleer de statussen die door de backend worden teruggegeven.',
  },
  board: {
    elapsedNow: 'Nu',
    elapsedMinutesAgo: '{{minutes}} min geleden',
    elapsedHoursAgo: '{{hours}} u geleden',
    elapsedDaysAgo: '{{days}} d geleden',
    productsCount: '{{count}} artikelen',
    paymentMethodTitle: 'Betaalmethode',
    orderCardAriaLabel:
      'Bestelling {{id}} · {{name}}. Enter om te openen, spatie om te slepen.',
    columnSubtitles: {
      inArrivo: 'Nieuwe bestellingen om te beoordelen',
      accettato: 'Bevestigde bestellingen',
      inLavorazione: 'Bestellingen in voorbereiding',
      pronto: 'Klaar om af te halen of te bezorgen',
    },
    archiveReadyTitle: 'Klare bestellingen archiveren',
    archiveReadyAriaLabel: 'Klare bestellingen archiveren',
    dropHere: 'Hier neerzetten',
    noOrders: 'Geen bestellingen',
    orderUpdatedRetry:
      'Bestelling bijgewerkt. Probeer het opnieuw met de huidige status.',
  },
  detail: {
    orderTitle: 'Bestelling #{{id}} · {{channel}}',
    orderDetail: 'Bestelgegevens',
    refreshOrderLabel: 'Bestelling vernieuwen',
    refreshOrderTitle: 'Bestelling vernieuwen',
    orderActivityLabel: 'Bestelactiviteit',
    orderActivityTitle: 'Bestelactiviteit',
    loadError: 'De bestelling kan niet worden geladen.',
    scheduledDelivery: 'Geplande bezorging',
    scheduledPickup: 'Geplande afhaling',
    deliveryAddress: 'Bezorgadres',
    pickupPoint: 'Afhaalpunt',
    emptyAddress: '—',
    outcome: 'Uitkomst:',
    orderDishes: 'Bestelde artikelen',
    editDishes: 'Artikelen bewerken',
    allergens: 'Allergenen:',
    perDish: '{{price}} / artikel',
    deliveryFeeLine: 'Delivery {{fee}}',
    orderUpdatedToast: 'Bestelling bijgewerkt.',
    operationFailed:
      'Bewerking mislukt. Laad de gegevens opnieuw en probeer het nogmaals.',
    moveOrder: 'Bestelling verplaatsen',
    orderNumber: 'Bestelling #{{id}}',
    chooseStatus: 'Status kiezen',
    reopenToStatus: 'Terug naar status',
    chooseOperationalStatus: 'Kies een operationele status',
    orderOutcome: 'Uitkomst van de bestelling',
    chooseReason: 'Kies een reden',
    confirmMove: 'Verplaatsing bevestigen',
    notifyCustomer: 'Klant op de hoogte stellen',
    doNotNotify: 'Niet melden',
    unpaidTitle: 'Bestelling nog niet betaald',
    unpaidBody:
      'Deze bestelling is nog niet betaald. Weet je zeker dat je haar naar in voorbereiding wilt verplaatsen?',
    unpaidHint:
      'De betaling blijft in behandeling. Met deze actie wordt de klant niet belast.',
    noActivity: 'Geen activiteit geregistreerd.',
    depositNotAuthorizedApi:
      'De aanbetaling is nog niet geautoriseerd. Wacht op de betalingsautorisatie van de klant.',
  },
  create: {
    title: 'Nieuwe bestelling',
    description:
      'Kies de service, voeg producten toe en vul de klantgegevens in.',
    loadServicesError: 'De services kunnen niet worden geladen.',
    loadingServices: 'Services laden…',
    publishServiceHint:
      'Publiceer een afhaal- of Delivery-service in Configuratie.',
    whichService: 'Welke service wil je gebruiken?',
    loadingMenuSlots: 'Menu en tijdvakken laden…',
    loadMenuSlotsError: 'Het menu en de tijdvakken kunnen niet worden geladen.',
    noModeAvailable: 'Geen modus beschikbaar voor deze service.',
    operationFailed: 'Bewerking mislukt. Probeer het opnieuw.',
    addAtLeastOneProduct: 'Voeg minstens één product toe.',
    productUnavailable: 'Een product is niet meer beschikbaar.',
    checkProducts: 'Controleer de producten.',
    enterCustomerName: 'Voer de voor- en achternaam van de klant in.',
    enterValidPhone: 'Voer een geldig telefoonnummer met landcode in.',
    fixOrClearEmail: 'Corrigeer het e-mailadres of laat het veld leeg.',
    chooseDayAndSlot: 'Kies een beschikbare dag en tijd.',
    chooseActiveDriver:
      'Kies een actieve bezorger of laat “Later toewijzen” staan.',
    enterFullDeliveryAddress:
      'Voer het volledige bezorgadres in, inclusief huisnummer.',
    reloadService: 'Laad de service opnieuw.',
    quoteExpired:
      'De offerte is verlopen. Controleer de gegevens en vernieuw het overzicht.',
    stepsAriaLabel: 'Stappen voor nieuwe bestelling',
    steps: {
      service: 'Service',
      products: 'Producten',
      customer: 'Klant',
      confirm: 'Bevestigen',
    },
    footerProductsTotal: '{{count}} artikelen · {{total}}',
    footerTotalOrder: 'Totaal bestelling',
    footerDeliveryInSummary: 'Bezorgkosten in overzicht',
    wait: 'Even geduld…',
    stepActions: {
      chooseProducts: 'Producten kiezen',
      customerDetails: 'Klantgegevens',
      reviewOrder: 'Bestelling controleren',
      createOrder: 'Bestelling aanmaken',
    },
    channelSectionTitle: 'Hoe ontvangt de klant de bestelling?',
    channelSectionHint:
      'Afhalen: de klant haalt de bestelling zelf op. Delivery: wij bezorgen.',
    channelTakeaway: 'Afhalen',
    channelDelivery: 'Delivery',
    changeChannelConfirm:
      'Van modus wisselen en de reeds toegevoegde producten wissen?',
    whatToOrder: 'Wat wil de klant bestellen?',
    menuCategoriesAriaLabel: 'Menucategorieën',
    allMenu: 'Volledig menu',
    otherProducts: 'Overige producten',
    searchProduct: 'Product zoeken',
    searchProductPlaceholder: 'Productnaam…',
    fromMenu: 'Uit het menu',
    addProductAria: '{{name}} toevoegen',
    compose: 'Configureren',
    add: 'Toevoegen',
    cartAriaLabel: 'Artikelen in bestelling',
    yourOrder: 'Je bestelling',
    chooseProductToStart: 'Kies een product uit het menu om te beginnen.',
    noExtraOptions: 'Geen extra opties',
    decreaseQtyAria: 'Aantal verlagen',
    decreaseQtyForAria: 'Aantal van {{name}} verlagen',
    quantityForAria: 'Aantal van {{name}}',
    increaseQtyForAria: 'Aantal van {{name}} verhogen',
    anotherConfiguration: 'Andere configuratie',
    removeConfigurationAria: 'Configuratie {{index}} verwijderen',
    subtotal: 'Subtotaal',
    customerAndFulfillment: 'Klant en {{fulfillment}}',
    fulfillmentDelivery: 'bezorging',
    fulfillmentPickup: 'afhaling',
    customerRequiredHint:
      'Voornaam, achternaam en telefoonnummer zijn verplicht.',
    emailOptional: 'E-mail (optioneel)',
    emailPlaceholder: 'klant@voorbeeld.nl',
    fullAddress: 'Volledig adres',
    fullAddressPlaceholder: 'Straat, nummer, postcode en plaats',
    driver: 'Bezorger',
    assignLater: 'Later toewijzen',
    driversLoadError:
      'De bezorgers kunnen niet worden geladen. Je kunt er later een toewijzen.',
    deliveryTime: 'Bezorgtijd',
    pickupTime: 'Afhaaltijd',
    bookUntil: 'Je kunt boeken tot {{date}}.',
    notesOptional: 'Opmerkingen (optioneel)',
    notesPlaceholder: 'Intercom, instructies voor de keuken…',
    reviewAndCreate: 'Bestelling controleren en aanmaken',
    driverLine: 'Bezorger:',
    toAssign: 'Toe te wijzen',
    afterCreateHint:
      'Na het aanmaken kun je de bestelling beheren en een aanbetaling aanvragen.',
    productConfigHint:
      'Kies de ingrediënten voor deze configuratie. Voor andere ingrediënten voeg je een andere configuratie toe.',
    requiredSuffix: ' · verplicht',
    quantity: 'Aantal',
    reduceQuantityAria: 'Aantal verlagen',
    addToOrder: 'Aan bestelling toevoegen',
    saveChanges: 'Wijzigingen opslaan',
    selection: {
      quantityRange: 'Kies een aantal tussen 1 en 99.',
      productUnavailableForService:
        'Product niet beschikbaar voor deze service.',
      optionUnavailable: 'Een van de geselecteerde opties is niet beschikbaar.',
    },
    cartErrors: {
      invalidLine: 'Ongeldige bestelregel.',
      maxSameConfiguration:
        'Je kunt maximaal 99 stuks van dezelfde configuratie toevoegen.',
      maxConfigurations: 'Maximaal 100 configuraties per bestelling.',
      configurationsRange: 'Voeg tussen 1 en 100 configuraties toe.',
      invalidAmountOrPercentage: 'Ongeldig bedrag of percentage.',
      checkOrderProducts: 'Controleer de producten in de bestelling.',
      minimumOrder: 'Minimale bestelling: € {{amount}}.',
      invalidDeliveryFee: 'Ongeldige bezorgkosten. Laad de service opnieuw.',
    },
  },
  history: {
    selectBranch: 'Selecteer een vestiging om bestellingen te bekijken.',
    subtitleDefault: 'Delivery & afhalen',
    searchTitle: 'Geschiedenis doorzoeken',
    searchHint:
      'Kies een periode of zoek een bestelling. De resultaten worden automatisch bijgewerkt.',
    searchPlaceholder: 'Bestelnummer, klant, product of contact…',
    moreFilters: 'Meer filters',
    invalidDateRange: 'Het datumbereik is niet geldig.',
    exporting: 'Exporteren…',
    exportCsv: 'CSV exporteren',
    exportFailed:
      'Exporteren mislukt. Er is geen gedeeltelijk bestand gedownload. Probeer het opnieuw.',
    driversListUnavailable: 'Lijst met bezorgers niet beschikbaar.',
    searchUnavailable:
      'Zoeken niet beschikbaar. De filters hebben geen geverifieerd resultaat opgeleverd.',
    searching: 'Bestellingen en overzichten zoeken…',
    exactMatch: 'Exacte overeenkomst',
    containsMatch: 'Zoeken op bevattende tekst',
    exactMatchHint: 'Langere namen worden niet meegenomen.',
    ordersFound: 'Gevonden bestellingen',
    ordersFoundHint: 'Op basis van de geselecteerde periode en filters',
    completedValue: 'Waarde van afgeronde bestellingen',
    completedValueHint:
      '{{count}} afgeronde bestellingen · totaalbedrag, ook als nog niet betaald',
    stillUnpaid: 'Nog onbetaald',
    noUnpaidInResults: 'Geen onbetaalde bestellingen in de resultaten',
    unpaidInResults: '{{count}} onbetaalde bestellingen in de resultaten',
    ordersByDriver: 'Bestellingen per bezorger',
    ordersByDriverHint:
      'Huidige toegewezen persoon, inclusief gearchiveerde bestellingen.',
    driverSummary: '{{completed}} afgerond · {{unpaid}} te innen',
    orderList: 'Bestellijst',
    orderListHint: 'Gebruik “Details” om een bestelling te openen.',
    resultsPage: '{{total}} resultaten · Pagina {{page}} van {{pages}}',
    loadingPage: 'Pagina laden…',
    noOrdersForFilters: 'Geen bestellingen voor deze filters',
    table: {
      order: 'Bestelling',
      dateTime: 'Datum en tijd',
      channel: 'Kanaal',
      orderStatus: 'Bestelstatus',
      payment: 'Betaling',
      driver: 'Bezorger',
      total: 'Totaal',
      notAssigned: 'Niet toegewezen',
      openOrderAria: 'Bestelling {{id}} openen',
    },
    modalProcessed: 'Verwerkte bestellingen',
    modalHistory: 'Bestelgeschiedenis',
    filters: {
      paid: 'Betaald',
      unpaid: 'Onbetaald',
      allMethods: 'Alle methoden',
      allDrivers: 'Alle',
      unassigned: 'Niet toegewezen',
      deliveryAndTakeaway: 'Delivery & afhalen',
      allStatuses: 'Alle',
      afterProcessed: 'Status na verwerking',
      sortBy: 'Sorteren op',
      sortRecent: 'Meest recent',
      sortOldest: 'Oudste',
      sortTotalHigh: 'Hoogste totaal',
      unassignedOnly: 'Niet toegewezen',
      driverFilter: 'Bezorger: {{name}}',
    },
    export: {
      incompleteResults: 'Onvolledige resultaten. Probeer het opnieuw.',
      filename: 'bestelgeschiedenis.csv',
      headers: {
        order: 'Bestelling',
        customer: 'Klant',
        email: 'E-mail',
        phone: 'Telefoon',
        schedule: 'Bezorging / afhaling',
        channel: 'Kanaal',
        products: 'Producten',
        driver: 'Bezorger',
        totalEur: 'Totaal EUR',
        orderStatus: 'Bestelstatus',
        paymentStatus: 'Betalingsstatus',
        paymentMethod: 'Betaalmethode',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: 'Per pagina',
      ordersCount: '{{count}} bestellingen',
      previous: 'Vorige',
      next: 'Volgende',
    },
    topCustomersHint:
      'Top 10 op waarde van voltooide bestellingen, over alle gefilterde resultaten.',
    noCompletedInResults: 'Geen afgeronde bestellingen in de resultaten.',
  },
  drivers: {
    manageHint:
      'Beheer medewerkers die aan bezorgingen kunnen worden toegewezen.',
    addDriver: 'Bezorger toevoegen',
    loadError: 'De bezorgers kunnen niet worden geladen.',
    empty: 'Geen bezorgers geconfigureerd',
    columns: {
      driver: 'Bezorger',
      phone: 'Telefoon',
      status: 'Status',
      actions: 'Acties',
    },
    active: 'Actief',
    inactive: 'Inactief',
    ordersAndMap: 'Bestellingen & kaart',
    deleteTitle: 'Bezorger verwijderen',
    deleteConfirm:
      '{{name}} verwijderen? De toegang wordt ingetrokken en openstaande bestellingen worden niet meer toegewezen. De geschiedenis blijft bewaard.',
    deleteAction: 'Bezorger verwijderen',
    deletedToast: 'Bezorger verwijderd.',
    deleteError: 'De bezorger kan niet worden verwijderd.',
    editTitle: 'Bezorger bewerken',
    newTitle: 'Nieuwe bezorger',
    username: 'Inlognaam',
    passwordNew: 'Wachtwoord · minstens 4 tekens',
    passwordKeep: 'Nieuw wachtwoord (leeg laten om het huidige te behouden)',
    passwordMinError: 'Voer minstens 4 tekens in.',
    accessHint:
      'De bezorger meldt zich aan via de scooterknop in het openbare menu. Deel de inloggegevens rechtstreeks met hem of haar. Het wachtwoord wordt niet opnieuw getoond.',
    activeToggleAria: 'Actieve bezorger',
    activeToggle: 'Actieve bezorger',
    savedToast: 'Bezorger opgeslagen.',
    saveError: 'De bezorger kan niet worden opgeslagen.',
    createdByDriver: 'Aangemaakt door bezorger:',
    assignedLabel: 'Toegewezen bezorger',
    notAssigned: 'Niet toegewezen',
    deactivatedSuffix: ' · gedeactiveerd',
    deletedSuffix: ' · verwijderd',
    driverLine: 'Bezorger:',
    assignSuccess: 'Bezorger toegewezen',
    unassignSuccess: 'Toewijzing verwijderd',
    assignError: 'De bezorger kan niet worden toegewezen.',
    discountCard: 'Kortingskaart',
    giftCard: 'Cadeaukaart:',
    giftCardCaptured: 'Afgeschreven',
    giftCardReleased: 'Vrijgegeven',
    giftCardReserved: 'Gereserveerd',
    amountDue: 'Te innen:',
  },
  config: {
    title: 'Configuratie Delivery & afhalen',
    sectionAriaLabel: 'Afhaal- en Delivery-services',
    introTitle: 'Beheer hoe je bestellingen ontvangt',
    introBody:
      'Gebruik Bewerken om het menu, de dagen, de tijden en de betalingen voor elke service in te stellen. Deel de link of QR-code zodat klanten kunnen bestellen.',
    searchPlaceholder: 'Service zoeken…',
    newService: 'Nieuwe service',
    templateLoadError: 'De beginwaarden kunnen niet worden geladen.',
    servicesLoadError: 'De services kunnen niet worden geladen.',
    emptySearch: 'Geen services komen overeen met je zoekopdracht',
    empty: 'Geen services geconfigureerd',
    columns: {
      service: 'Service',
      orderType: 'Type bestelling',
      visibility: 'Zichtbaarheid',
      manageShare: 'Beheren & delen',
    },
    preparationMinutes: 'Bereiding {{minutes}} min',
    advanceDays: 'Bestellen tot {{days}} dagen vooruit',
    deliveryPausedSuffix: ' · gepauzeerd',
    visibleToCustomers: 'Zichtbaar voor klanten',
    draftNotVisible: 'Concept · niet zichtbaar',
    openPage: 'Pagina openen',
    servicesPerPage: 'Services per pagina',
    range: '{{start}}–{{end}} van {{total}}',
    previous: 'Vorige',
    next: 'Volgende',
    linkCopied: 'Link gekopieerd.',
    copyManually: 'Kopieer de getoonde link handmatig.',
    removedToast: 'Service verwijderd. Bestaande bestellingen blijven bewaard.',
    removeError: 'De service kan niet worden verwijderd.',
    shareModalTitle: 'Klantlink · {{name}}',
    published: 'Gepubliceerd',
    draftPublishHint:
      'Concept · publiceer de service om bestellingen te ontvangen',
    publicLinkLabel: 'Openbare Delivery- / afhaallink',
    shareHint:
      'De klant kiest uit de ingeschakelde kanalen en beschikbare tijdvakken voor deze service.',
    removeTitle: 'Service verwijderen',
    removeConfirm:
      '“{{name}}” verwijderen? De service accepteert geen nieuwe bestellingen meer. Bestaande bestellingen en de geschiedenis blijven bewaard.',
    removeAction: 'Service verwijderen',
    editor: {
      editTitle: 'Service bewerken',
      newTitle: 'Nieuwe service',
      stepService: '1 · Service',
      stepProducts: '2 · Producten',
      stepSchedulePayments: '3 · Planning & betalingen',
      savePublish: 'Opslaan & publiceren',
      saveDraft: 'Concept opslaan',
      serviceName: 'Servicenaam',
      serviceNameHint:
        'Deze naam is de titel van de openbare pagina die klanten via de link of QR-code openen om te bestellen voor Delivery of afhalen.',
      chooseMenu: 'Menu kiezen',
      menusLoadError: 'De menu’s kunnen niet worden geladen.',
      enableTakeaway: 'Afhalen inschakelen',
      enableDelivery: 'Delivery inschakelen',
      restaurantPhoto: 'Restaurantfoto (optioneel)',
      restaurantPhotoHint:
        'Klik om een foto van je apparaat te kiezen en te uploaden.',
      removeRestaurantPhoto: 'Restaurantfoto verwijderen',
      photoLoading: 'Foto uploaden…',
      photoUploadedToast: 'Foto geüpload. Sla de service op om te bevestigen.',
      photoUploadError: 'De restaurantfoto kan niet worden geüpload.',
      photoNoUrl:
        'Bij het uploaden is geen afbeeldings-URL teruggegeven. Probeer het opnieuw.',
      productsIntro:
        'Kies de beschikbare producten en prijzen per kanaal. Ingrediënten en varianten komen uit het gedeelde menu. Klik op Opslaan naast het veld om een gewijzigde prijs te bevestigen.',
      searchProductsPlaceholder: 'Product of sectie zoeken…',
      productsLoadError: 'De producten kunnen niet worden geladen.',
      productsLoading: 'Producten laden…',
      noProducts: 'Geen producten gevonden',
      chooseMenuFirst: 'Kies eerst een menu',
      sectionControlsHint:
        '{{count}} producten · de bediening geldt voor de hele sectie, ook tijdens het zoeken.',
      partial: ' · Gedeeltelijk',
      activeCount: '{{enabled}}/{{total}} actief',
      sectionToggleAria: '{{channel}}: hele sectie {{name}}',
      product: 'Product',
      takeaway: 'Afhalen',
      delivery: 'Delivery',
      options: 'Ingrediënten & opties',
      syncedWithMenu: ' · Gesynchroniseerd met menu',
      priceAria: '{{channel}}-prijs {{name}}',
      savePriceAria: '{{channel}}-prijs {{name}} opslaan',
      invalidPrice:
        'Voer een geldige prijs in die groter dan of gelijk aan nul is.',
      updateFailed: 'Bijwerken mislukt',
      productsUpdatedPartial:
        '{{completed}} van {{total}} producten bijgewerkt. Niet bijgewerkt: {{failures}}',
      priceUpdatedToast: 'Prijs bijgewerkt.',
      productsUpdatedToast: '{{count}} producten bijgewerkt.',
      menuLoadFailed:
        'Het menu kan niet worden geladen. Er zijn geen wijzigingen toegepast.',
      recipeSyncHint:
        'Schakelaars van gesynchroniseerde producten werken het recept direct bij, ook in het menu en in andere services die het gebruiken. Hier opgeslagen prijzen werken ook het menu en andere services bij. Annuleren maakt deze wijzigingen niet ongedaan. Sla bij niet-gesynchroniseerde producten de service op om te bevestigen. Bewerk ingrediënten in het menu.',
      prepMinutes: 'Gemiddelde bereidingstijd (min)',
      slotMinutes: 'Duur van tijdvak voor bezorging/afhaling (minuten)',
      slotHint:
        'Bij 15 minuten kan de klant 19:00–19:15 kiezen, daarna 19:15–19:30. De bereidingstijd wordt apart ingesteld.',
      advanceDaysLabel: 'Maximale vooruitbestelperiode (dagen)',
      advanceDaysHint:
        'Bij 7 dagen kan de klant bestellen voor een datum binnen de komende 7 dagen, tijdens de ingestelde openingstijden.',
      minimumOrder: 'Minimale bestelling (€)',
      freeDeliveryFrom: 'Gratis bezorging vanaf (€)',
      deliveryRadius: 'Bezorgradius (km)',
      weeklyCalendar:
        'Weekkalender · tijden voor het ontvangen van bestellingen',
      from: 'Van',
      slotStartAria: 'Begin tijdvak {{index}}',
      slotEndAria: 'Einde tijdvak {{index}}',
      removeSlotAria: 'Tijdvak verwijderen',
      addSlot: 'Tijdvak toevoegen',
      paymentMethods: 'Geaccepteerde betaalmethoden',
      cardOnly: 'Alleen kaart',
      cashAndCard: 'Contant & kaart',
      stripeChecking: 'Stripe controleren…',
      stripeRequired:
        'Voltooi de Stripe-configuratie en de onboarding van de vestiging om kaartbetalingen in te schakelen.',
      cardStripeError:
        'Voltooi de Stripe-configuratie en de onboarding van de vestiging om kaartbetalingen in te schakelen.',
      publication: 'Publicatie',
      pauseDelivery: 'Delivery tijdelijk pauzeren',
      pauseDeliveryHint:
        'Het Delivery-gedeelte van deze service kan tijdelijk worden uitgeschakeld. Schakel het weer in door het vinkje weg te halen en de service op te slaan. Afhalen blijft beschikbaar als het is ingeschakeld.',
      publishService: 'Service publiceren',
      savedPublishedToast: 'Service opgeslagen als gepubliceerd.',
      savedDraftToast: 'Concept opgeslagen.',
      saveError: 'De service kan niet worden opgeslagen.',
      pendingPrices:
        'Sla gewijzigde prijzen op met de knop naast elk veld voordat je verdergaat.',
      distanceBandsUnsupported:
        'De gekoppelde API moet worden bijgewerkt om afstandsschalen op te slaan.',
      distanceBandsNotReturned:
        'De server heeft de opgeslagen schalen niet teruggegeven. De configuratie blijft open: laad de service opnieuw voordat je het nogmaals probeert.',
      productDetailsTitle: 'Productdetails · {{name}}',
      productDetails: 'Productdetails',
      closeDetails: 'Details sluiten',
      ingredients: 'Ingrediënten:',
      allergens: 'Allergenen:',
      notSpecified: 'Niet opgegeven',
      noOptionsForChannel: 'Geen opties voor dit kanaal',
      group: 'Groep',
      ingredient: 'Ingrediënt',
      supplement: 'Supplement',
      minMax: 'Min. {{min}}{{max}}',
      maxSuffix: ' · Max. {{max}}',
      weekdays: {
        monday: 'Maandag',
        tuesday: 'Dinsdag',
        wednesday: 'Woensdag',
        thursday: 'Donderdag',
        friday: 'Vrijdag',
        saturday: 'Zaterdag',
        sunday: 'Zondag',
      },
    },
    validation: {
      serviceName: 'Voer een servicenaam in (maximaal 120 tekens).',
      chooseMenu: 'Kies het menu van de service.',
      enableChannel: 'Schakel minstens Delivery of afhalen in.',
      integerRange:
        '{{label}}: voer een geheel getal in tussen {{min}} en {{max}}.',
      preparation: 'Bereiding',
      slotDuration: 'Duur van tijdvak',
      bookableDays: 'Boekbare dagen',
      amounts: 'Voer positieve bedragen in met maximaal twee decimalen.',
      deliveryRadius:
        'De bezorgradius moet groter zijn dan 0 en maximaal 100 km bedragen.',
      timezone: 'Voer een geldige tijdzone in.',
      location:
        'Vul het adres en de coördinaten aan in de vestigingsconfiguratie.',
      geocoding:
        'De verificatieservice voor het bezorggebied is niet geconfigureerd.',
      openingHours: 'Voer tussen 1 en 28 openingstijdvakken in.',
      openingHoursOrder:
        'Controleer de openingstijdvakken: de eindtijd moet na de begintijd liggen.',
      enableProduct: 'Schakel minstens één product in voor een actief kanaal.',
      productPrices: 'Controleer de productprijzen.',
    },
  },
  modals: {
    archive: {
      title: 'Klare bestellingen archiveren',
      intro:
        'De geselecteerde bestellingen worden gearchiveerd: Delivery als Bezorgd, afhalen als Afgehaald. De betaalmethode blijft ongewijzigd.',
      markAllPaid: 'Alle geselecteerde als betaald markeren',
      deliverySection: 'Delivery · Bezorgd',
      takeawaySection: 'Afhalen · Afgehaald',
      paid: 'Betaald',
      noReadyOrders: 'Geen klare bestellingen.',
      archiving: 'Archiveren…',
      archiveCount: '{{count}} bestellingen archiveren',
      archiveError:
        'Archiveren mislukt. Laad de bestellingen opnieuw en probeer het nogmaals.',
    },
    processed: {
      title: 'Verwerkte bestellingen · {{date}}',
      searchPlaceholder: 'Zoek op klant, telefoon of bestelnummer…',
      orderOutcome: 'Uitkomst van de bestelling',
      allReasons: 'Alle redenen',
      empty: 'Geen gearchiveerde bestellingen',
      columns: {
        order: 'Bestelling',
        channel: 'Kanaal',
        schedule: 'Bezorg- / afhaaltijd',
        total: 'Totaal',
        driver: 'Bezorger',
        outcome: 'Uitkomst',
        payment: 'Betaling',
      },
      perPage: 'Per pagina',
      ordersCount: '{{count}} bestellingen',
      previous: 'Vorige',
      next: 'Volgende',
    },
    payment: {
      cardTitle: 'Kaartbetaling',
      loadingStripe: 'Stripe-formulier laden…',
      loadError:
        'De betaling kan niet worden geladen. De bestelling is opgeslagen en wacht op betaling.',
      retryPayment: 'Betaling opnieuw proberen',
      payAmount: '{{amount}} betalen',
      confirmedOnPayment:
        'De bestelling wordt bevestigd zodra de betaling is ontvangen.',
      paymentFailed: 'Betaling mislukt. Probeer het opnieuw.',
      paymentIncomplete: 'Betaling niet voltooid. Probeer het opnieuw.',
      verifyFailed:
        'De betaling kan niet worden geverifieerd. Probeer het opnieuw voor dezelfde bestelling.',
    },
    itemsEditor: {
      title: 'Artikelen bewerken',
      titleWithOrder: 'Artikelen bewerken · Bestelling #{{id}}',
      loadError:
        'Voor het bewerken van bestellingen zijn de nieuwe backend-API’s nodig. Er zijn geen gegevens gewijzigd.',
      loadingMenu: 'Menu laden…',
      notEditable:
        'Deze bestelling kan in de huidige status niet worden bewerkt.',
      saveError:
        'Opslaan niet mogelijk. Laad de bestelling opnieuw als een andere medewerker deze heeft gewijzigd.',
      menuChannel: 'Menu · {{channel}}',
      searchPlaceholder: 'Gerecht of sectie zoeken…',
      orderItems: 'Bestelde artikelen · {{count}}',
      removeDishAria: 'Gerecht verwijderen',
      quantity: 'Aantal',
      decreaseQtyAria: 'Aantal verlagen',
      optionIssue:
        'Controleer de beschikbaarheid en het minimum/maximum van de geselecteerde ingrediënten.',
      addAtLeastOne:
        'Voeg minstens één artikel toe. Gebruik de daarvoor bestemde actie om de bestelling te annuleren.',
      verifiedTotal: 'Geverifieerd nieuw totaal',
      recalcHint:
        'De server berekent prijzen en supplementen opnieuw voordat er wordt opgeslagen. Wijzigingen blijven lokaal tot “Wijzigingen opslaan”.',
      verifyTotal: 'Nieuw totaal verifiëren',
      saveChanges: 'Wijzigingen opslaan',
      unsavedConfirm:
        'Verlaten zonder de wijzigingen aan artikelen op te slaan?',
      dishFallback: 'Artikel {{index}}',
    },
  },
  address: {
    suggestionsUnavailable:
      'Suggesties niet beschikbaar. Probeer het zo opnieuw om de straat te selecteren.',
    searching: 'Adressen zoeken…',
    suggestionsCount:
      '{{count}} voorgestelde adressen. Gebruik de pijltjestoetsen om te kiezen en Enter om te bevestigen.',
    notFound:
      'Geen adres gevonden. Controleer de straat en voeg de plaats toe.',
    verifyStreet: 'Straat en huisnummer verifiëren…',
    verifyFailed:
      'We konden de straat niet verifiëren. Selecteer opnieuw een suggestie om het nogmaals te proberen.',
    selectFromSuggestions:
      'Selecteer de straat uit de suggesties voordat je verdergaat.',
    deliveryAddressSrOnly: 'Bezorgadres',
    placeholder: 'Straat, nummer, plaats en postcode',
    suggestedAddressesAria: 'Voorgestelde adressen',
    hint: 'Kies de straat uit de suggesties en vul het huisnummer aan.',
    streetNumber: 'Huisnummer *',
    streetNumberPlaceholder: 'bijv. 10, 10/A',
    deliveryAddressPreview: 'Bezorgadres:',
    yourAddress: 'Jouw adres',
    streetOnlyCity:
      'Selecteer een straat uit de suggesties, niet alleen een plaats of gebied.',
    fullAddressItaly:
      'Selecteer een volledig adres met straat en plaats in Italië.',
    streetNumberRequired: 'Voer het huisnummer in om verder te gaan.',
    streetNumberInvalid:
      'Voer een geldig huisnummer in, bijv. 10, 10/A of 10 bis.',
  },
  pricing: {
    ariaLabel: 'Bezorgkosten',
    title: 'Hoe bereken je de bezorgkosten?',
    intro:
      'Kies één tarief voor iedereen of een totaalprijs voor elke afstandsschaal.',
    fixedCost: 'Vaste kosten',
    distanceBands: 'Afstandsschalen',
    fixedFeeLabel: 'Kosten per bezorging (€)',
    fixedFeeHint: 'Hetzelfde bedrag voor alle adressen binnen de bezorgradius.',
    bandsUnsupported:
      'De gekoppelde API’s ondersteunen het opslaan van schalen nog niet. Je kunt ze hier voorbereiden; opslaan is beschikbaar nadat de service is bijgewerkt.',
    bandsFlow:
      '1. Adres binnen een straal van {{radius}} km → 2. Wegroute → 3. Kosten van de schaal',
    bandsFlowHint:
      'De prijs zijn de totale bezorgkosten. Kilometers zijn de enkele wegafstand van de locatie naar de klant. De laatste schaal dekt elke grotere afstand voor reeds geaccepteerde adressen.',
    allDistances: 'Alle afstanden',
    overKm: 'Meer dan {{km}} km',
    lastBandHint: 'Laatste schaal · geen extra wegbeperking',
    bandUpTo: 'Schaal {{index}} · tot (km)',
    bandFromZero: 'Vanaf 0 km, limiet inbegrepen.',
    bandAfterPrevious: 'Na {{km}} km, limiet inbegrepen.',
    bandCost: 'Schaal {{index}} · totale kosten (€)',
    removeBandAria: 'Schaal {{index}} verwijderen',
    addBand: 'Schaal toevoegen',
    bandChecksAria: 'Schaalcontroles',
    simulateDistance: 'Wegafstand simuleren (km)',
    completeBandsForCost: 'Vul de schalen aan om de kosten te zien.',
    enterValidDistance: 'Voer een geldige wegafstand in.',
    costAtDistance: 'Bezorgkosten bij {{km}} km: {{price}}',
    previewHint:
      'Voorbeeld van de schaalprijs, vóór een eventuele drempel voor gratis bezorging.',
    bandErrors: {
      count: 'Voer tussen 1 en 30 afstandsschalen in.',
      lastBand:
        'Schaal {{index}}: de laatste schaal dekt alle grotere afstanden.',
      distance:
        'Schaal {{index}}: voer een afstand in die groter is dan de vorige, tot 1.000 km.',
      fee: 'Schaal {{index}}: voer kosten in van 0 tot 999.999,99 € met maximaal twee decimalen.',
    },
  },
  payment: {
    sectionAria: 'Betaling van bestelling',
    paid: 'Betaald',
    markPaid: 'Als betaald markeren',
    paymentStatus: 'Betalingsstatus',
    toPay: 'Te betalen',
    saving: 'Betaling opslaan…',
    specialStatusHint:
      'Betalingen van bestellingen die in behandeling, terugbetaald of geannuleerd zijn, vereisen een aparte controle.',
    updateError:
      'De betaling kan niet worden bijgewerkt. Laad de bestelling opnieuw en probeer het nogmaals.',
    branchUnavailable: 'Vestiging niet beschikbaar.',
    deposit: {
      ariaLabel: 'Aanbetaling aanvragen',
      title: 'Een aanbetaling aanvragen',
      intro:
        'Kies het percentage van het totaal van {{total}}. De klant ontvangt een link om te betalen.',
      received: 'Ontvangen:',
      remaining: 'Nog te betalen:',
      defaultUnavailable: 'Betaallinks niet beschikbaar: configureer Stripe.',
      verifyBeforeNew:
        'De betaling van deze bestelling moet worden gecontroleerd voordat een nieuwe aanbetaling wordt aangevraagd.',
      creating: 'Aanmaken…',
      linkCreated: 'Link aangemaakt',
      createLinkFor: 'Link aanmaken voor {{amount}}',
      requested: 'Aanbetaling aangevraagd: {{amount}}',
      customerLink: 'Klantlink',
      messageSent: 'Bericht wordt verzonden / verzonden',
      sending: 'Verzenden…',
      sendWhatsApp: 'Via WhatsApp naar de klant sturen',
      copied: 'Gekopieerd',
      copyLink: 'Link kopiëren',
      copyFromField: 'Kopieer de link uit het veld hierboven.',
      whatsAppHint:
        'Gebruikt het bericht “Betaallink” dat in het Berichtencentrum is ingesteld. Het aanmaken of verzenden van de link markeert de bestelling niet als betaald.',
      requestMismatch:
        'Het teruggegeven verzoek komt niet overeen met de gekozen aanbetaling. Laad de bestelling opnieuw.',
      requestUnavailable:
        'Verzoek niet beschikbaar. De API-service moet aanbetalingen op bestellingen ondersteunen.',
      sendNotConfirmed: 'Verzending niet bevestigd.',
      sendError:
        'Het bericht kan niet worden verzonden. Controleer de WhatsApp-configuratie voor het bericht “Betaallink”.',
      invalidPaymentRequest: 'Ongeldig betalingsverzoek.',
      invalidPaymentLink: 'Ongeldige betaallink.',
    },
  },
  labels: {
    inArrivo: 'Binnenkomend',
    accettato: 'Geaccepteerd',
    archiviato: 'Verwerkt',
    accept: 'Bestelling accepteren',
    archive: 'Als verwerkt markeren',
    reopen: 'Bestelling heropenen',
    eliminato: 'Verwijderd',
    nonConsegnato: 'Niet bezorgd',
    delivery: 'Delivery',
    takeaway: 'Afhalen',
    ricevuto: 'Ontvangen',
    presaInCarico: 'In behandeling genomen',
    confermato: 'In behandeling genomen',
    inAttesaDiPagamento: 'Wacht op betaling',
    inLavorazione: 'In voorbereiding',
    pronto: 'Klaar',
    ritirato: 'Afgehaald',
    inConsegna: 'Onderweg',
    consegnato: 'Bezorgd',
    rifiutato: 'Geweigerd',
    annullato: 'Geannuleerd',
    nonRitirato: 'Niet afgehaald',
    consegnaFallita: 'Bezorging mislukt',
    daPagare: 'Te betalen',
    inAttesa: 'In behandeling',
    pagato: 'Betaald',
    parzialmentePagato: 'Aanbetaling ontvangen',
    unspecified: 'Nog te bepalen',
    fallito: 'Mislukt',
    rimborsato: 'Terugbetaald',
    cash: 'Contant',
    card: 'Kaart',
    takeCharge: 'In behandeling nemen',
    reject: 'Bestelling weigeren',
    prepare: 'Voorbereiding starten',
    ready: 'Als klaar markeren',
    assign: 'Bezorger toewijzen',
    dispatch: 'Vertrekken voor bezorging',
    collect: 'Afhaling bevestigen',
    deliver: 'Bezorging bevestigen',
    fail: 'Probleem melden',
    cancel: 'Bestelling annuleren',
    cashPaid: 'Contante betaling registreren',
    refund: 'Terugbetalen op kaart',
    cashRefund: 'Contante terugbetaling registreren',
    notCollected: 'Niet afgehaald',
    active: 'Te beheren',
    completed: 'Afgerond',
    issues: 'Geannuleerd / problemen',
    scheduleAsap: 'Zo snel mogelijk',
  },
};
